const state = {
  isOffline: true
}

export default state